import React from 'react';
import PropTypes from 'prop-types';
import ImageViewer from './image-viewer.js';
export { DEFAULTS } from './consts.js';
import { alignmentClassName, sizeClassName } from './classNameStrategies.js';
import { Loader, MediaItemErrorMsg } from 'wix-rich-content-ui-components';
import './wixImage.js';
import 'classnames';
import './types.js';
import 'lodash';
import 'wix-rich-content-common';
import '@wix/image';
import './icons/expand.js';
import './InPluginInput.js';
import './style-inject.es-746bb8ed.js';
import 'wix-rich-content-common/dist/statics/schemas/plugin-image.schema.json';
import './image-viewer.rtlignore-4c2a6716.js';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ImageComponent extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleMetadataChange", (newMetadata) => {
      const { componentData } = this.props;
      const metadata = __spreadValues(__spreadValues({}, componentData.metadata), newMetadata);
      this.props.store.update(
        "componentData",
        __spreadProps(__spreadValues({}, componentData), { metadata }),
        this.props.block.getKey()
      );
    });
    __publicField(this, "handleCaptionChange", (caption) => this.handleMetadataChange({ caption }));
    const { block, store } = this.props;
    if (store) {
      const blockKey = block.getKey();
      store.setBlockHandler("handleMetadataChange", blockKey, this.handleMetadataChange.bind(this));
    }
  }
  render() {
    var _a;
    const {
      settings,
      componentData,
      className,
      blockProps,
      theme,
      isMobile,
      helpers,
      getInPluginEditingMode,
      setInPluginEditingMode,
      setComponentUrl,
      t
    } = this.props;
    const { error } = componentData;
    const dataUrl = ((_a = this.props.tempData) == null ? void 0 : _a.dataUrl) || componentData.tempData;
    const isLoading = !error && (this.props.isLoading || componentData.loading || componentData.tempData);
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      ImageViewer,
      {
        theme,
        isMobile,
        helpers,
        getInPluginEditingMode,
        setInPluginEditingMode,
        componentData,
        className,
        isLoading,
        dataUrl,
        settings,
        defaultCaption: this.props.t("ImageViewer_Caption"),
        onCaptionChange: this.handleCaptionChange,
        setFocusToBlock: blockProps.setFocusToBlock,
        setComponentUrl
      }
    ), isLoading && /* @__PURE__ */ React.createElement(Loader, { type: "medium" }), error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t }));
  }
}
__publicField(ImageComponent, "alignmentClassName", (componentData, theme, styles, isMobile) => alignmentClassName(componentData, theme, styles));
__publicField(ImageComponent, "sizeClassName", (componentData, theme, styles, isMobile) => sizeClassName(componentData, theme, styles, isMobile));
ImageComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
  blockProps: PropTypes.object.isRequired,
  block: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  settings: PropTypes.object,
  helpers: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  getInPluginEditingMode: PropTypes.func,
  setInPluginEditingMode: PropTypes.func,
  isMobile: PropTypes.bool.isRequired,
  setComponentUrl: PropTypes.func,
  isLoading: PropTypes.bool,
  tempData: PropTypes.object
};

export { ImageComponent as Component };
//# sourceMappingURL=image-component.js.map
